// socketActions.ts
import { createAction } from "@reduxjs/toolkit";
import { UserState, SET_PLAYERDATA } from "../reducers/userReducer";
import { PermissionType, PlayerType, SET_HOUSEDATA } from "../reducers/hardmoneyReducer";
import { UIState, SET_activeTab, SET_hidden, SET_slideClass, SET_schemeColor } from "../reducers/uiReducer";

type ConnectSocket = {
    wsIP: string;
}

export const CONNECT_SOCKET = createAction<Partial<ConnectSocket> | undefined>("socket/connect");
export const DISCONNECT_SOCKET = createAction("socket/disconnect");

type SendSocketMessage = {
    subType: string;
    userData: UserState;
    uiData: UIState;
}

export const SEND_SOCKET_MESSAGE = createAction<SendSocketMessage>("socket/sendPlayerData");

type GetSocketData = {
    houseName: string;
    sid: number;
}

export const GET_SOCKET_DATA = createAction<GetSocketData>("socket/getSocketData");


export const OPEN_UI = createAction<GetSocketData>("socket/openUi");


export const CLOSE_UI = createAction<GetSocketData>("socket/closeUi");